import * as React from 'react';
import { Props } from '../types/types';

import { Container, Row, Col } from 'react-bootstrap';
import { View, Text, rem } from '../libs/WebComponents';
import { QuestionType } from '../store/questions';


const QuestionOpen = (props: Props) => {
   const [isValid, setIsValid] = React.useState(props.page.required ? false : true);
   const [openText, setOpenText] = React.useState('');


   React.useEffect(()=>{
      props.setCanNext(isValid);
      props.setShowExplanationPage(()=>()=>props.showTip(props.page.question_type));

      return ()=>{
         props.setCanNext(true);
         props.setShowExplanationPage(null);
      }
   },[isValid]);

   const _changeAnswers = React.useCallback((e: any) => {
      setOpenText(e.target.value ? e.target.value : '');
   },[]);


   React.useEffect(()=>{
      const valid = openText !==''? true : false;
      props.setAnswers({open_text:String(openText)});
      if (props.page.required && valid!==isValid) setIsValid(valid);

   },[openText, isValid]);

   React.useEffect(()=>{
      if (props.given_answers && props.given_answers.open_text && props.given_answers.open_text !=='')
      {
         setOpenText(props.given_answers.open_text);
      }
   },[props.given_answers]);

   return (
      <Container>
         <Row className={'justify-content-center'}>
            <Col className={'col-lg-10 col-xl-8'}>
               <View style={{marginBottom:rem(3)}}/>
               <Text h4>Kun je een toelichting geven?</Text>
               <View style={{marginBottom:rem(1)}}/>
               <textarea placeholder={'Begin met schrijven …'} className={'form-control'} rows={8} onChange={_changeAnswers} onBlur={_changeAnswers} defaultValue={openText ? openText : ''} />
            </Col>
         </Row>
      </Container>
   );

}


export default React.memo(QuestionOpen);